import { SearchType } from '@zoopla/listing-search-context';
import { Page } from '@zoopla/listing-search/factory';

const { SearchPageWithApollo } = Page({ type: SearchType.ToRent });

export default SearchPageWithApollo;
